// jQueryプラグイン
export function mediaFunc() {
  let mediaTop = $('#mediaTop').length;

  let resizecheck = $('#responsibleCheck').width();
  
  $(window).on('resize', function () {
    resizecheck = $('#responsibleCheck').width();
  });

  if(mediaTop){

    let topicsArchivesList = $('.topicsArchivesList .archivesBtn');
    let topicsFlg = 0;
    topicsArchivesList.on('click', function () {
      if (resizecheck == '2') {
        $(this).stop().toggleClass('open');
        $(this).next().stop().slideToggle(500);
      }
    });

    //マウスを乗せたら発動
    $('#topicsArchivesList').hover(function () {
      if (resizecheck == '1') {
        $(this).find('dd').stop().slideToggle(500)
        topicsArchivesList.stop().addClass('open');
        //ここにはマウスを離したときの動作を記述
      }
    }, function () {
      if (resizecheck == '1') {
        $(this).find('dd').stop().slideToggle(500);
        topicsArchivesList.stop().removeClass('open');
        //ここにはマウスを離したときの動作を記述
      }

    });


    let topicsCategoryList = $('.topicsCategoryList .categoryBtn');
    topicsCategoryList.on('click', function () {
      if (resizecheck == '2') {
        $(this).stop().toggleClass('categoryOpen');
        $(this).next().stop().slideToggle(500);
      }
    });


    $('.topicsCategoryList').hover(function () {
      if (resizecheck == '1') {
        $(this).find('dd').stop().slideToggle(500)
        topicsCategoryList.stop().addClass('categoryOpen');
        //ここにはマウスを離したときの動作を記述
      }
    }, function () {
      if (resizecheck == '1') {
        $(this).find('dd').stop().slideToggle(500);
        topicsCategoryList.stop().removeClass('categoryOpen');
        //ここにはマウスを離したときの動作を記述
      }
    });

  }
}